export const getEnvironment = () => {
  return window.location.host.split("-")[0] === "staging"
    ? "staging"
    : window.location.host.split(".")[0].indexOf("localhost") >= 0
    ? "staging"
    : "production";
};

export default { getEnvironment };
